import { ref, watchEffect } from 'vue';
import { useMapUIStore } from '@/stores/MapUIStore';


export const useMapAutoRefresh = () => {
  const mapUIStore = useMapUIStore();
  const mapRefreshId = ref(null);
  const visibilityHiddenTimestamp = ref(null);

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      clearInterval(mapRefreshId.value)
      visibilityHiddenTimestamp.value = Date.now()

      return;
    }

    start()
  })

  const start = () => {
    if (mapUIStore.mapAutoRefresh == 0) return;

    let refreshTimeout = mapUIStore.mapAutoRefresh;

    if (visibilityHiddenTimestamp.value) {
      const timeHidden = Date.now() - visibilityHiddenTimestamp.value;
      const timeLeft = mapUIStore.mapAutoRefresh - timeHidden;
      refreshTimeout = timeLeft > 0 ? timeLeft : mapUIStore.mapAutoRefresh;
    }

    clearInterval(mapRefreshId.value);

    mapRefreshId.value = setInterval(refreshMap, refreshTimeout);
  }

  const refreshMap = () => {
    window.location.reload();
  }

  watchEffect(() => {
    mapUIStore.mapAutoRefresh && start();
  })

  return { start }
}

